import PropTypes from 'prop-types'

export const BusinessPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  score: PropTypes.number,
  type: PropTypes.string,
  version: PropTypes.number,
})

export const BusinessPermitPropType = PropTypes.shape({
  reviewSource: PropTypes.string,
  userName: PropTypes.string,
  location: PropTypes.string,
  reviewDate: PropTypes.any,
  reviewRating: PropTypes.number,
  reviewText: PropTypes.string,
  buildingType: PropTypes.string,
  valuation: PropTypes.number,
  permit: PropTypes.string,
  status: PropTypes.string,
  fee: PropTypes.number,
  permitType: PropTypes.string,
})

export const BusinessProjectReviewPropType = PropTypes.shape({
  reviewSource: PropTypes.string,
  userName: PropTypes.string,
  location: PropTypes.string,
  relationship: PropTypes.string,
  reviewRating: PropTypes.number,
  projectDate: PropTypes.any,
  projectPriceAsString: PropTypes.string,
  status: PropTypes.string,
  reviewText: PropTypes.string,
  reviewBuildingType: PropTypes.string,
})

export const BusinessLicensePropType = PropTypes.shape({
  licenseExpirationDate: PropTypes.string,
  licenseNumber: PropTypes.string,
  licenseRegisteredAddress: PropTypes.string,
  licenseType: PropTypes.string,
})
